import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, count = null, size = "w-4 h-4", showCount = true }) => {
  const rounded = Math.round(value);
  return (
    <span className="inline-flex items-center gap-1" data-testid="star-rating">
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            className={`${size} ${n <= rounded ? "text-sage fill-sage" : "text-darkRoast/20"}`}
            strokeWidth={1.5}
          />
        ))}
      </span>
      {showCount && count !== null && (
        <span className="text-xs text-earth ml-1">
          {count > 0 ? `${value.toFixed(1)} (${count})` : "No reviews yet"}
        </span>
      )}
    </span>
  );
};
